import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { CollapsedOverlay, Container } from "./CollapsableContainer.styles";
export var CollapsableContainer = function(param) {
    var ref = param.behavior.ref, children = param.children, _rules = param.rules, canBeCollapsed = _rules.canBeCollapsed, isCollapsed = _rules.isCollapsed;
    return /*#__PURE__*/ _jsxs(Container, {
        isCollapsed: isCollapsed,
        ref: ref,
        children: [
            children,
            canBeCollapsed && /*#__PURE__*/ _jsx(CollapsedOverlay, {
                isCollapsed: isCollapsed
            })
        ]
    });
};
